<template>
  <v-main id="policy_details" class="policy-overview-content pt-0 pb-10 mb-16" role="presentation">
    <v-container class="maxContainerWidth mt-4">
      <!-- Start -->
      <v-row class="text-white">
        <!-- My Primerica Header -->
        <v-col
          class="d-flex flex-wrap"
          :class="$vuetify.display.xs ? 'align-start' : 'align-center'"
        >
          <svg
            width="55px"
            height="40px"
            viewBox="15 10 42 35"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <title>Life Insurance</title>
            <defs>
              <radialGradient
                cx="51.4182051%"
                cy="82.466338%"
                fx="51.4182051%"
                fy="82.466338%"
                r="70.4153415%"
                gradientTransform="translate(0.514182,0.824663),scale(0.698177,1.000000),rotate(77.265059),scale(1.000000,1.064158),translate(-0.514182,-0.824663)"
                id="radialGradient-511"
              >
                <stop stop-color="#36A5DD" offset="0%" />
                <stop stop-color="#286EB6" offset="100%" />
              </radialGradient>
              <radialGradient
                cx="51.4182051%"
                cy="82.466338%"
                fx="51.4182051%"
                fy="82.466338%"
                r="303.039601%"
                gradientTransform="translate(0.514182,0.824663),scale(0.234861,1.000000),rotate(45.568421),scale(1.000000,1.064158),translate(-0.514182,-0.824663)"
                id="radialGradient-611"
              >
                <stop stop-color="#36A5DD" offset="0%" />
                <stop stop-color="#286EB6" offset="100%" />
              </radialGradient>
            </defs>
            <g id="Nav-House" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Blue-Level-Icon2" transform="translate(12.000000, 11.000000)">
                <g>
                  <polygon
                    id="Rectangle"
                    fill="#18344E"
                    points="6.39435792 8.78385542 19.6767558 1.41036145 32.9435943 8.78385542 32.9591537 25.7838554 6.39435792 25.7838554"
                  />
                  <path
                    d="M0.0481927711,10.1108701 L4.76705398,10.1181643 L4.76705398,27.2296386
                    L34.468165,27.2296386 L34.468165,10.1181643 L39.0481928,10.1181643 L31.4197199,6.14855624 L31.4191647,0.143222694 L26.1423416,0.143222694
                    L26.1423416,3.4009463 L19.6152197,0.000722891566 L0.0481927711,10.1108701 Z M6.40023796,9.21092306 L19.5343354,2.41036145 L32.939759,9.35099862
                    L32.939759,19.759759 L6.39156627,19.759759 L6.40023796,9.21092306 Z"
                    id="Blue-Level-Icon"
                    fill="url(#radialGradient-511)"
                  />
                  <path
                    d="M6.89402838,19.259759 L6.89057366,24.499759 L32.4563424,24.499759 L32.4589087,19.259759 L6.89402838,19.259759 Z"
                    id="Rectangle"
                    stroke="#18344E"
                    fill="url(#radialGradient-611)"
                  />
                </g>
              </g>
            </g>
          </svg>
          <h1
            role="heading"
            aria-level="1"
            class="text-h1 text-white ml-n1 text-wrap"
            :class="$vuetify.display.xs ? 'w-75' : 'w-auto'"
          >
            {{ $t('L_life_insurance') }}
          </h1>
          <v-spacer v-if="!$vuetify.display.xs"></v-spacer>
          <!-- Policy Number -->
          <h3 class="text-white" :class="$vuetify.display.xs ? 'ml-9 pl-4' : 'ml-0 pl-0'">
            {{ $t('L_policy_number') }}:
            <span class="font-weight-regular">{{ policyNo }}</span>
          </h3>
        </v-col>
      </v-row>

      <!-- End -->
      <v-row>
        <v-col cols="12" class="bottomSpace">
          <ChildRiderSteps />
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { useGlobalStore } from '@/stores/global/global.store';
import { mapState, mapStores } from 'pinia';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import ChildRiderSteps from './components/ChildRiderSteps.vue';

const componentOptions: ComponentOptions = {
  name: 'ChildRiderPage',
  components: {
    ChildRiderSteps,
  },
  computed: {
    ...mapStores(useGlobalStore),
    ...mapState(usePolicyStore, {
      currentPolicy: 'currentPolicy',
    }),
    policyNo() {
      return this.currentPolicy?.contractId;
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.my-primerica-header-layout {
  justify-content: center;
  .heading_two {
    padding-right: 16px;
  }
}
.maxContainerWidth {
  max-width: 960px;
  margin: 0 auto;
}
.bottomSpace {
  margin-bottom: 82px;
}
</style>
